export enum KindType {
    ASSET = '0',
    LIABILITY = '1',
    REVENUE = '2',
    EXPENSE = '3',
    FORWARD = '4',
    DEBTOR = '5',
    CREDITOR = '6',
}
